import type { PaginateResourceResponse } from "types";
import type { OnboardingApplicationStepAndFieldHistoryLogEntry } from "features/onboarding/types";

export const withGroupByResource = ({ data, ...paginator }: PaginateResourceResponse<OnboardingApplicationStepAndFieldHistoryLogEntry>['data']) => ({
    ...paginator,
    data: (Object as any).groupBy(data, ({
        resource
    }: OnboardingApplicationStepAndFieldHistoryLogEntry) => resource)
});
